// import { Trello } from "../../../../@types/my-trello-types";
// import trelloColors from "../../../shared/styles/trello-colors";
import AttachedRemovedCard from "./_attached-removed-card";
import CardsGroup from "../shared/cards-group/cards-group";
import { Trello } from "../../../../../external/trello-pu__core/trello-iframe/trello";
import trelloColors from "../../../../styles/trello-colors";

type TProps = {
  cards: Trello.Attachment[];
  shortLinkCurrentCard: string;
  onRemoveClick(idAttachment: string): void;
  isCollapsed: boolean;
  onGroupCollapsedToggle(): void;
  mode: "removed" | "unauthorized";
};

const UnavailableCardsList = (props: TProps) => {
  const boardColor = trelloColors.N50;
  const attachedCardsArray = props.cards.map((a) => (
    <AttachedRemovedCard
      key={a.id}
      attachment={a}
      onRemoveAttachmentRequest={props.onRemoveClick}
    />
  ));
  return (
    <CardsGroup
      key={null}
      boardColor={boardColor}
      boardName={
        props.mode == "removed" ? "Removed cards" : "Unauthorized to view"
      }
      isCollapsed={props.isCollapsed}
      onToggleCollapsedClick={() => props.onGroupCollapsedToggle()}
    >
      {attachedCardsArray}
    </CardsGroup>
  );
};

export default UnavailableCardsList;
